/**
 * Shared frontend configuration constants.
 * Single source of truth — do not hardcode these values elsewhere.
 */
export const ALLOWED_DOMAIN = process.env.REACT_APP_ALLOWED_DOMAIN || 'terra-inspectioneering.com';
